export const environment = {
    API_HOST:"https://techsuredcms.webuildgreatsoftware.co.za",
    API_TOKEN:"484ce2fbf8e3c1f68f7a2f2f99dc300793c1f61ab11ed93dcbce2ce124a7f7a42f13396b483a1ee4ef47d7645a3e1bf9cb1da28a233426b0023b27c60dff29f8a34ec227a2a539a87549dda8eb5656d50d60f9579d8f729a5712e4e98b968e6df9c7a502ebf08aae3a048dad5a9e988b9229ead84be185fd3f45885bd176c7a7"
};